/* istanbul ignore file */
import React from 'react';
import { CheckboxGroup } from 'framework/form';
import { CheckboxGroupLayoutType } from '../../../CheckboxGroupFilter';

const CheckboxGroupFilterLayout: CheckboxGroupLayoutType = props => {
  return <CheckboxGroup {...props} />;
};

export default CheckboxGroupFilterLayout;
